import React from 'react';
import loadable from '@loadable/component';

export default loadable(
    () => import(/* webpackChunkName: "ListLandingPageLazy" */ './ListLandingPageConnect'),
    {
        fallback: <div>Loading...</div>,
    }
);
